/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentAttachment } from '../../models/content-attachment';
import { ContentAttachmentDetail } from '../../models/content-attachment-detail';

export interface UploadAttachment$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID verzie
 */
  versionId: number;
      body?: ContentAttachment
}

export function uploadAttachment(http: HttpClient, rootUrl: string, params: UploadAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentAttachmentDetail>> {
  const rb = new RequestBuilder(rootUrl, uploadAttachment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('versionId', params.versionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentAttachmentDetail>;
    })
  );
}

uploadAttachment.PATH = '/admin/content/{id}/version/{versionId}/attachment';
